export type PrinterFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type PrinterFilterGroup = {
  id: string;
  label: string;
  options: PrinterFilterOption[];
};

export const printerFilterGroups: PrinterFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'hp', label: 'HP', keywords: ['hp'] },
      { value: 'canon', label: 'Canon', keywords: ['canon'] },
      { value: 'brother', label: 'Brother', keywords: ['brother'] },
      { value: 'epson', label: 'Epson', keywords: ['epson'] },
      { value: 'pantum', label: 'Pantum', keywords: ['pantum'] },
      { value: 'xprinter', label: 'Xprinter', keywords: ['xprinter'] },
      { value: 'ecoprint', label: 'Ecoprint', keywords: ['ecoprint'] },
    ],
  },
  {
    id: 'machine-type',
    label: 'Loại máy',
    options: [
      {
        value: 'multifunction',
        label: 'Máy in đa chức năng',
        keywords: ['da chuc nang', 'multifunction'],
      },
      { value: 'inkjet', label: 'Máy in phun', keywords: ['in phun', 'inkjet'] },
      { value: 'laser', label: 'Máy in laser', keywords: ['in laser', 'laser printer'] },
      { value: 'receipt', label: 'Máy in hoá đơn', keywords: ['in hoa don', 'receipt printer'] },
      { value: 'barcode', label: 'Máy in mã vạch', keywords: ['in ma vach', 'barcode printer'] },
      { value: 'scan', label: 'Máy scan', keywords: ['scan'] },
    ],
  },
  {
    id: 'series',
    label: 'Dòng máy',
    options: [
      {
        value: 'bw',
        label: 'Máy in đen trắng',
        keywords: ['den trang', 'black and white', 'monochrome'],
      },
      { value: 'color', label: 'Máy in màu', keywords: ['in mau', 'color printer'] },
    ],
  },
  {
    id: 'function',
    label: 'Chức năng',
    options: [
      { value: 'duplex', label: 'In 2 mặt tự động', keywords: ['2 mat', 'duplex'] },
      { value: 'copy', label: 'Copy', keywords: ['copy'] },
      { value: 'scan-fn', label: 'Scan', keywords: ['scan'] },
      { value: 'fax', label: 'Fax', keywords: ['fax'] },
    ],
  },
  {
    id: 'connectivity',
    label: 'Chuẩn kết nối',
    options: [
      { value: 'lan', label: 'LAN', keywords: ['lan', 'rj45'] },
      { value: 'usb', label: 'USB', keywords: ['usb'] },
      { value: 'wireless', label: 'Wireless', keywords: ['wireless', 'wifi'] },
    ],
  },
  {
    id: 'speed',
    label: 'Tốc độ in',
    options: [
      { value: 'normal', label: 'Phổ thông', keywords: ['pho thong', 'standard'] },
      { value: 'medium', label: 'Trung bình', keywords: ['trung binh', 'medium'] },
      { value: 'fast', label: 'Nhanh', keywords: ['nhanh', 'fast'] },
      { value: 'very-fast', label: 'Rất nhanh', keywords: ['rat nhanh', 'very fast'] },
    ],
  },
];
